import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import DeliveryStatusFooter from '../../delivery-status/DeliveryStatusFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FailedFooterWrapper = styled.div.withConfig({
  displayName: "AutomatedMessageFooter__FailedFooterWrapper",
  componentId: "sc-1vz52xs-0"
})(["margin-top:-4px;margin-bottom:6px;"]);
const AutomatedMessageFooter = ({
  status,
  timestamp,
  positionDescriptors,
  visitorLastReadTimestamp
}) => {
  if (status.messageStatus === 'FAILED') {
    return /*#__PURE__*/_jsx(FailedFooterWrapper, {
      children: /*#__PURE__*/_jsxs(Small, {
        use: "error",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "warning",
          className: "m-right-1"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.DEFAULT"
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(DeliveryStatusFooter, {
    timestamp: timestamp,
    status: status,
    positionDescriptors: positionDescriptors,
    visitorLastReadTimestamp: visitorLastReadTimestamp
  });
};
AutomatedMessageFooter.displayName = 'AutomatedMessageFooter';
export default AutomatedMessageFooter;